/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {recordCompletedJourneyBatch} from '../api'

export const useMutationRecordCompletedJourneyBatch = createReactQueryMutationHook('recordCompletedJourneyBatch', recordCompletedJourneyBatch)
